import { render, staticRenderFns } from "./AddTeamFromApplication.vue?vue&type=template&id=6d015b4a"
import script from "./AddTeamFromApplication.vue?vue&type=script&lang=js"
export * from "./AddTeamFromApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports